// extracted by mini-css-extract-plugin
export default {"achievementContainer":"CVWork_achievementContainer__T-1Cv","achievementTitle":"CVWork_achievementTitle__E2uJW","achievements":"CVWork_achievements__z7iIZ"};